/**
 * スムーススクロール
 * @type {number}
 */
import AccordionSwitch from "../functions/accordion";

$(window).on('load', function () {
    let speed = 500;
    let ease = "easeInOutCubic";

    $('a[href^="#"]').on("click", function () {
        let href = $(this).attr("href");
        let target = $(href == "#" || href == "" ? "html" : href);  // ターゲットを取得
        let position = target.offset().top;

        // 各種数値とその他仕様のアコーディオンは遷移時に一緒に展開
        if ($('#' + target.attr('id') + ' .accordion-box').length) {
            $('#' + target.attr('id')).find(".accordion-box").each(function (index, element) {
                new AccordionSwitch($(element), false); // アコーディオン関数を実行
            });
        }

        // スムーススクロール実行
        $("html,body").animate({scrollTop: position}, speed, ease);

        return false;
    });

});